import React, { createContext, useEffect, useState } from 'react';
import { formatDate } from '../../utils';

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [filteredBody, setFilteredBody] = useState({});

  const [dateFromLtFilter, setDateFromLtFilter] = useState();
  const [dateToGtFilter, setDateToGtFilter] = useState();
  const [locationId, setLocationId] = useState('');
  const [serviceId, setServiceId] = useState('');

  useEffect(() => {
    setFilteredBody(filteredBody => ({
      ...filteredBody,
      location_id: locationId,
      service_type: serviceId,
    }));
  }, [locationId, serviceId]);

  const handleSubmit = name => {
    const generatedFilter = {};

    if (dateFromLtFilter) {
      generatedFilter.date_from = formatDate(dateFromLtFilter);
    }
    if (dateToGtFilter) {
      generatedFilter.date_to = formatDate(dateToGtFilter);
    }
    if (locationId) {
      generatedFilter.location_id = locationId;
    }
    if (serviceId) {
      generatedFilter.service_type = serviceId;
    }

    if (name) {
      setFilteredBody(generatedFilter);
    }
  };

  const clearFilters = () => {
    setLocationId('');
    setServiceId('');
    setDateToGtFilter();
    setDateFromLtFilter();

    setFilteredBody({});
  };

  return (
    <DashboardContext.Provider
      value={{
        filteredBody,
        setFilteredBody,
        dateFromLtFilter,
        setDateFromLtFilter,
        dateToGtFilter,
        setDateToGtFilter,
        locationId,
        setLocationId,
        serviceId,
        setServiceId,
        handleSubmit,
        clearFilters,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
